
import { PropType, defineComponent } from 'vue';
import TrailerWithWarning from './TrailerWithWarning.vue';
import ReturnOptions from '@/components/ReturnOptions.vue';

export default defineComponent({
    name: 'SingleMessageCard',
    components: {
        ReturnOptions,
        TrailerWithWarning,
    },
    props: {
        trailerNumber: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        trailerStatusSubtitle: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        trailerStatusTitle: {
            type: String as PropType<string | undefined>,
            required: true,
        },
        detailsDescription: {
            type: String as PropType<string | undefined>,
            required: true,
        },
    },
});
